var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.5,22.5v3.778a1.889,1.889,0,0,1-1.889,1.889H6.389A1.889,1.889,0,0,1,4.5,26.278V22.5",
    transform: "translate(0 -6.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.5,15l4.722,4.722L19.944,15",
    transform: "translate(-2.222 -3.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,15.833V4.5",
    transform: "translate(-5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.82018defbaca25802623f2c77e6abb90.svg";
export { ForwardRef as ReactComponent };